import { pnTokenManager } from '@pn/core/services/authentication/tokenManager';
import { STACKDX_URL } from '@pn/core/urls';
import { makeRequest, type ApiRequestParams } from './apiClient';

export const stackApiClient = {
  request: <T>(params: ApiRequestParams, companyId: string) =>
    makeRequest<T>({
      baseUrl: STACKDX_URL + '/',
      tokenManager: pnTokenManager,
      extraHeaders: {
        'X-Company-Id': companyId,
      },
      params,
    }),
};
